import { render, staticRenderFns } from "./render-vxe.vue?vue&type=template&id=122faf00"
import script from "./render-vxe.vue?vue&type=script&lang=js"
export * from "./render-vxe.vue?vue&type=script&lang=js"
import style0 from "./render-vxe.vue?vue&type=style&index=0&id=122faf00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports